import type {
  BffLogicalDeviceListResponseApi,
  BffLogicalDeviceResourceReadApi,
} from '@ingenico/api-sdk-provisioning-private';
import type { BffPaginatedLogicalDeviceList } from '../../models/logicalDeviceList.model';

export function mapBffLogicalDeviceListResponseApiToPaginatedLogicalDeviceList({
  data,
  ...rest
}: BffLogicalDeviceListResponseApi): BffPaginatedLogicalDeviceList {
  return {
    ...rest,
    logicalDevices: data.map(
      (element) =>
        ({
          ...element,
        }) as BffLogicalDeviceResourceReadApi,
    ),
  };
}
